import React, { useState } from 'react';
import styled from 'styled-components';
import i_modify from '../../../src/images/common/i_modify_on.svg';
import URL from '../../constants/url';
import { Link, useNavigate } from 'react-router-dom';
import alram_on from '../../../src/images/common/i_alram_on.svg';
import alram_off from '../../../src/images/common/i_alram_off.svg';
import AlertBox from '../../components/box/AlertBox';

//감정 일지 컨퍼넌트

const RecordContent = styled.div`
    display: block;
    margin-top: var(--sp-12);
`;

const InnerBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: var(--sp-16);
    border-radius: var(--radius-16);
    background-color: var(--color-white);

    &.disabled {
        filter:grayscale(1);
        border: 1px dashed var(--color-main-gray-10);
    }
`;

const InfomBox = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    gap: var(--sp-04);
    flex-grow: 1;
    width: 100%; 
    position: relative;
    z-index: 1;
`;

const TopBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sp-08);
`;

const MealChip = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--sp-20);
    padding: 0 var(--sp-10);
    border-radius: var(--radius-12);
    background-color: var(--color-main-25);
    font-size: var(--mo-fz-sm);
    color: var(--color-main-5);
    font-weight: var(--fz-weight-700);
`;

const MidBox = styled.div`
    display: flex;
    flex-direction: column;
`;

const TypoTit = styled.div`
    & p {
    font-size: var(--mo-fz-smd);
    color: var(--color-main-gray);
    font-weight: var(--fz-weight-700);
    }
    & p.complete {
        color: var(--color-main-5);
    }
`;

const TypoSub = styled.p`
    font-size: var(--mo-fz-sm);
    color: var(--color-main-gray);
    font-weight: var(--fz-weight-400);
    white-space: nowrap;
    width: 100%;         /* width가 반드시 필요 */
    /*max-width: 370px;  */
    overflow: hidden;
    text-overflow: ellipsis;
`;

const TypoDetail = styled.p`
    display: flex;

    & > span {
        display: flex;
        align-items: center;
        padding: 0 var(--sp-08);
        font-size: var(--mo-fz-sm);
        color: var(--color-main-gray-5);
    }
    & > span:first-child {
        padding: 0;
    }
    & > span:first-child:after {
        content: '';
        display: block;
        width: 1px;
        height: 9px;
        margin-left: var(--sp-08);
        background-color: var(--color-main-gray-5);
    }
`;

const ControlBox = styled.div`
    display: flex;
    align-items: center;
    gap: var(--sp-10);
    & .alarm-status-box {
        & span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: var(--sp-20);
            height: var(--sp-20);
            background-image: url(${alram_off});
        }& span[data-alarm="on"] {
            background-image: url(${alram_on});
        }   
    }
`;


const ControlTake = styled.div`
    position: relative;
    z-index:2;
    & > button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: var(--sp-02);
        height: var(--sp-24);
        padding: 0 var(--sp-08) 0 var(--sp-06);
        background-color: transparent;
        font-size: var(--mo-fz-sm);
        color: var(--color-main-5);
        font-weight: var(--fz-weight-700);
        transform: scale(1);
        transition: transform 0.4s;
    }
    & > button:active {
        transform: scale(0.9);
    }
`;

const Layout = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const HealthRecordBox = ({ title, alarmChk, write, usrSrveyRsltId, date, surveyData }) => {

    const navigate = useNavigate();
    const today = new Date().toISOString().split('T')[0].replace(/-/g, ''); // YYYYMMDD
    const isPastOrToday = date <= today; // 문자열 비교

    // cntsEndDe 체크 (종료된 설문인지 확인)
    const cntsEndDe = surveyData?.item?.cntsEndDe;
    const isExpired = cntsEndDe && cntsEndDe < today;

    // 팝업
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };


    const handleNavigate = (e) => {
        if (e) e.stopPropagation();

        if (!isPastOrToday) {
            setAlertText('미래 날짜는 작성 및 수정이 불가합니다.');
            setIsAlertOpen(true);
            return;
        }

        // 종료된 설문은 클릭 막기
        if (isExpired) {
            return;
        }

        navigate(surveyData.url, { state: { item: surveyData.item } });
    };

    return (
        <RecordContent>
            <InnerBox className={isExpired ? 'disabled' : ''}>
                <InfomBox onClick={handleNavigate}>

                    {write ? (
                        <>
                            <Layout>
                                <MidBox>
                                    <TypoTit>
                                        <p className='complete'>{title} 작성 완료!</p>
                                    </TypoTit>
                                </MidBox>
                                {!isExpired && (
                                    <ControlBox>
                                        <ControlTake>
                                            <button onClick={handleNavigate}>
                                                <img src={i_modify}></img> 수정
                                            </button>
                                        </ControlTake>
                                    </ControlBox>
                                )}
                            </Layout>
                        </>
                    ) : (
                        <>
                            <TopBox>
                                <MealChip>{surveyData?.item?.reqreTmCn}</MealChip>
                                {!isExpired && (
                                    <ControlBox>
                                        <div
                                            className="alarm-status-box"
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                // cntsEndDe와 오늘 날짜 비교 (지난 설문 체크)
                                                const cntsEndDe = surveyData?.item?.cntsEndDe;
                                                if (cntsEndDe && cntsEndDe < today) {
                                                    setAlertText('종료된 설문은 확인이 불가합니다.');
                                                    setIsAlertOpen(true);
                                                    return;
                                                }

                                                navigate('/HealthDetail', {
                                                    state: {
                                                        surveyItem: surveyData?.item
                                                    }
                                                });
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span data-alarm={alarmChk === "1" ? "on" : null}></span>
                                        </div>

                                        <ControlTake>
                                            <button onClick={handleNavigate}> 작성하기</button>
                                        </ControlTake>
                                    </ControlBox>
                                )}
                            </TopBox>
                            <MidBox>
                                <TypoTit>
                                    <p>{title}</p>
                                </TypoTit>
                                <TypoSub>
                                    {surveyData?.item?.srveyDc1}
                                </TypoSub>
                                <TypoDetail>
                                    <span>{surveyData?.item?.insttNm}</span>
                                    <span>{surveyData?.item?.cnncDeptNm}</span>
                                </TypoDetail>
                            </MidBox>
                        </>
                    )}

                </InfomBox>
            </InnerBox>

            <AlertBox
                isOpen={isAlertOpen}
                onClose={handleOnAlertClose}
                message={alertText}
                btnTxt='확인'
            />

        </RecordContent>
    );
};

export default React.memo(HealthRecordBox);
